export const questionTexts = {
    utdypendeSporsmal: {
        utfordringerMedArbeid: {
            label: 'Hva er den viktigste medisinske grunnen til at pasienten ikke kan være i arbeidsrelatert aktivitet eller gradert  arbeid nå?',
        },
        medisinskOppsummering: {
            label: 'Gi en kort medisinsk oppsummering relevant for sykefraværet (hovedsymptomer og relevante funn, samt behandling/plan)',
        },
        hensynPaArbeidsplassen: {
            label: 'Hvis arbeidsrelatert aktivitet skal prøves: er det medisinske hensyn eller begrensninger som bør legges til grunn? (ikke obligatorisk)',
            description:
                'Oppgi kort hva som bør unngås eller hvilke rammer som må gjelde, for eksempel begrensninger i belastning/tempo/varighet, behov for pauser eller skjerming, triggere som gir forverring eller forhold som gjør aktivitet medisinsk uforsvarlig nå)',
        },
        sykdomsutvikling: {
            label: 'Gi en kort oppdatering på sykdomsutviklingen siden uke 7, med vekt på endringer i symptomer og funn som er relevante for det videre sykefraværet',
        },
        arbeidsrelaterteUtfordringer: {
            label: 'Beskriv kort hvilke utfordringer helsetilstanden gir for arbeidsdeltakelse nå. Oppgi også kort hva pasienten likevel kan mestre',
            description:
                'Tenk på forhold som: fysisk belastning, utholdenhet, tempo, konsentrasjon, samhandling med andre, stress - og kravtoleranse, behov for pauser eller skjerming',
        },
        behandlingOgFremtidigArbeid: {
            label: 'Beskriv pågående og planlagt utredning/behandling, og om dette forventes å påvirke muligheten for økt arbeidsdeltakelse fremover',
        },
        uavklarteForhold: {
            label: 'Er det forhold som fortsatt er uavklarte eller hindrer videre arbeidsdeltakelse, som Nav bør være kjent med i sin oppfølging?',
        },
        oppdatertMedisinskStatus: {
            label: 'Gi en kort oppdatering på sykdomsutviklingen siden uke 17, med vekt på endringer i symptomer og funn som er relevante for det videre sykefraværet',
        },
        realistiskMestringArbeid: {
            label: 'Hva kan pasienten realistisk sett mestre av arbeidsdeltakelse nå, og hvilke helserelaterte forhold begrenser dette?',
            descriptionSomatisk:
                '(somatiske lidelser): Tenk eksempelvis på pasientens kapasitet og tålegrenser når det gjelder fysisk belastning, utholdenhet, tempo, smerteprovokasjon, behov for pauser, stillingskifte eller skjerming)',
            descriptionPsykisk:
                '(psykiske lidelser, utmattelse, post-covid): Tenk på pasientens kapasitet når det gjelder eksempelvis konsentrasjon, oppmerksomhet, stress- og kravtoleranse, samhandling med andre, struktur, beslutningstaking eller for for skjerming/pauser',
        },
        forventetHelsetilstandUtvikling: {
            label: 'Hvordan forventes helsetilstanden å utvikle seg de neste 3-6 månedene med tanke på mulighet for økt arbeidsdeltakelse?',
            answerOptions: {
                forventetBedring: 'Forventet bedring - økt arbeidsdeltakelse realistisk',
                gradvisBedring: 'Gradvis bedring - omfang usikkert',
                littEndring: 'Lite endring forventes',
                uavklart: 'Uavklart - avhenger av pågående avklaring/behandling',
            },
        },
        medisinskeHensyn: {
            label: 'Er det medisinske hensyn eller avklaringsbehov Nav bør kjenne til i videre oppfølging?',
        },
    },
}
